import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
// Self-hosted fonts (DESIGN.md: Nunito display, Inter body, JetBrains Mono code).
import '@fontsource/nunito/500.css';
import '@fontsource/nunito/600.css';
import '@fontsource/nunito/700.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource-variable/jetbrains-mono';
// Light syntax-highlight theme (paper-white canvas).
import 'highlight.js/styles/github.css';
import './style.css';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');
